import { render } from "./videoChat.vue?vue&type=template&id=490e018b"
import script from "./videoChat.vue?vue&type=script&lang=js"
export * from "./videoChat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__